if(BSS_B2B) {  
  setTimeout(() => {
    
      function debounce(func, delay) {
          let timeoutId;
          return function() {
              const context = this;
              const args = arguments;
              clearTimeout(timeoutId);
              timeoutId = setTimeout(() => func.apply(context, args), delay);
          };
      }
  
      let handleInputChange = debounce(() => {
          BSS_B2B.changeProductPriceWithInterval();
      }, 300);
      
  
      let input = document.querySelector("#Search > div > div.Search__SearchBar > form > input.Search__Input.Heading");
  
      input && input.addEventListener("input", handleInputChange);
  
      let shippingBarContainer = document.querySelectorAll('.ec-shipping-bar-container, #EliteCart');
      let observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  try {
                    fetch("/cart.js")
                    .then(response => response.json())
                    .then(data => {
                        let items = document.querySelectorAll(".ec-lineitem-container");
                        items.forEach((item, index) => {
                          const itemData = data.items.find(it => it.product_title === (item.querySelector(".ec-lineitem-title a") || {}).textContent);
                          console.log("item:", item)
                            let title = item.querySelector(".ec-lineitem-title a");
                            if (itemData && itemData.product_title === title.textContent) {
                                let price = item.querySelector(".ec-lineitem-price");
                            // khong gan bss-b2b-item-original-price: BSS se ghi de gia goc cua EliteCart bang money format hong
                                if(!price.parentElement.parentElement.querySelector(".bss-b2b-cart-vat")){
                                     const subtotal = document.querySelector(".ec-summary-subtotal dd");
                        const subtotal1 = document.querySelector(".ec-summary-total dd")
                          if(subtotal){
                            subtotal.parentElement?.querySelector(".bss-b2b-cart-vat-subtotal")?.remove();
                            subtotal.insertAdjacentHTML("afterend", `
                            <div class="bss-b2b-cart-vat-subtotal" data-cart-total-price="${data.total_price}">
                        	<span class="bss-b2b-cart-no-vat-price"  data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}' ></span>
                        	<span class="bss-b2b-cart-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}' ></span>
                      </div>
                            `)
                          }
                      if(subtotal1){
                        subtotal1.parentElement?.querySelector(".bss-b2b-cart-vat-subtotal")?.remove();
                           subtotal1.insertAdjacentHTML("afterend", `
                            <div class="bss-b2b-cart-vat-subtotal" data-cart-total-price="${data.total_price}">
                        	<span class="bss-b2b-cart-no-vat-price"  data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}' ></span>
                        	<span class="bss-b2b-cart-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}' ></span>
                      </div>
                            `)
                      }
                                    price.parentElement.insertAdjacentHTML("afterend", `
                                <div
  class="bss-b2b-cart-vat"
  data-cart-item-id="${itemData.id}"
  data-cart-vat-item-key="${ itemData.key}"
  data-cart-variant-taxable="${ itemData.taxable}"
  data-cart-item-final-price="${ itemData.final_price}">
  <span class="bss-b2b-cart-item-no-vat-price"    data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}'></span>
  <span class="bss-b2b-cart-item-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}'></span>
</div>
                                `)
                                }
                              
                            }
                        });
                        document.querySelector(".ec-summary-total dd")?.setAttribute("bss-b2b-cart-total-price", "");
                        document.querySelector(".ec-summary-subtotal dd")?.setAttribute("bss-b2b-cart-total-price", "");
                        BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false);
                    });
                  } catch(e) {}
              }
          });
      });
    
      fetch("/cart.js")
                    .then(response => response.json())
                    .then(data => {
                          const subtotal = document.querySelector(".ec-summary-subtotal dd");
                        const subtotal1 = document.querySelector(".ec-summary-total dd")
                          if(subtotal){
                            subtotal.insertAdjacentHTML("afterend", `
                            <div class="bss-b2b-cart-vat-subtotal" data-cart-total-price="${data.total_price}">
                        	<span class="bss-b2b-cart-no-vat-price"  data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}' ></span>
                        	<span class="bss-b2b-cart-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}' ></span>
                      </div>
                            `)
                          }
                      if(subtotal1){
                           subtotal1.insertAdjacentHTML("afterend", `
                            <div class="bss-b2b-cart-vat-subtotal" data-cart-total-price="${data.total_price}">
                        	<span class="bss-b2b-cart-no-vat-price"  data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}' ></span>
                        	<span class="bss-b2b-cart-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}' ></span>
                      </div>
                            `)
                      }
                      
                        let items = document.querySelectorAll(".ec-lineitem-container");
                        items.forEach((item, index) => {
                          const itemData = data.items.find(it => it.product_title === (item.querySelector(".ec-lineitem-title a") || {}).textContent);
                            let title = item.querySelector(".ec-lineitem-title a");
                            if (itemData && itemData.product_title === title.textContent) {
                                let price = item.querySelector(".ec-lineitem-price");
                                price.parentElement.insertAdjacentHTML("afterend", `
                                <div
  class="bss-b2b-cart-vat"
  data-cart-item-id="${itemData.id}"
  data-cart-vat-item-key="${ itemData.key}"
  data-cart-variant-taxable="${ itemData.taxable}"
  data-cart-item-final-price="${ itemData.final_price}">
  <span class="bss-b2b-cart-item-no-vat-price"    data-excluded-vat-text='${BSS_B2B.taxDisplayTranslations.excluded_vat_text}'></span>
  <span class="bss-b2b-cart-item-with-vat-price" data-included-vat-text='${BSS_B2B.taxDisplayTranslations.included_vat_text}'></span>
</div>
                                `)
                                }
                        });
      })
                           BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false);
      var observerOptions = {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
      };
      shippingBarContainer.forEach(item => {
        
      observer.observe(item, observerOptions);
      })
      BSS_B2B.handleCartCheckoutBtn(JSON.parse($('#bss-b2b-store-data').html()))  
  }, 2000)
}

